import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Star } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const initials = (name) => name.split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase();

const Stars = ({ count }) => (
  <div className="stars">
    {Array.from({ length: 5 }, (_, i) => (
      <Star key={i} size={13} fill={i < count ? "currentColor" : "none"} opacity={i < count ? 1 : 0.35} />
    ))}
  </div>
);

export const Reviews = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    axios.get(`${API}/testimonials`).then((r) => setReviews(r.data)).catch(() => setReviews([]));
  }, []);

  const avg = reviews.length ? (reviews.reduce((s, r) => s + (r.rating || 5), 0) / reviews.length).toFixed(1) : "5.0";

  return (
    <section className="section reviews-section" id="reviews">
      <div className="container">
        <div className="section-heading">
          <div>
            <p className="overline">Kind words</p>
            <h2>Moves that made <em>the difference.</em></h2>
          </div>
          <p className="section-sub">Real stories from people who trusted us with their most important things.</p>
        </div>
        <div className="review-grid" data-testid="reviews-grid">
          {reviews.map((review, i) => (
            <motion.article
              key={review.id}
              className={`review-card ${i === 0 ? "featured-review" : ""}`}
              data-testid={`review-card-${i + 1}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.08, duration: 0.65 }}
            >
              <div className="quote-mark">“</div>
              <p>{review.text}</p>
              <div className="reviewer">
                <span className="review-avatar">{initials(review.name)}</span>
                <div><strong>{review.name}</strong><small>{review.route}</small></div>
                <Stars count={review.rating || 5} />
              </div>
            </motion.article>
          ))}
          <div className="review-badge" data-testid="review-rating-summary">
            <Star size={18} fill="currentColor" />
            <strong>{avg}</strong>
            <span>average rating<br />across every move</span>
          </div>
        </div>
      </div>
    </section>
  );
};
